(() => {
  'use strict';
  const selector='shopify-apple-pay-button,shopify-google-pay-button';
  document.querySelectorAll('[data-ae-device-wallet-policy]').forEach(wallets=>{
    const actions=wallets.closest('.ae-checkout-actions');
    let frame=0;
    const position=()=>{
      frame=0;
      const native=wallets.querySelector('shopify-accelerated-checkout-cart'),selected=wallets.querySelector('[data-ae-device-wallet-selected]');
      if(!native||!selected||wallets.hidden||wallets.inert)return;
      const anchor=native.getBoundingClientRect(),rect=selected.getBoundingClientRect(),style=getComputedStyle(selected);
      if(!anchor.width||!rect.height)return;
      const offsets={'--ae-device-wallet-x':anchor.left-rect.left+(parseFloat(style.left)||0),'--ae-device-wallet-y':anchor.top-rect.top+(parseFloat(style.top)||0)};
      Object.entries(offsets).forEach(([name,value])=>{const next=Math.round(value*1000)/1000+'px';const previous=parseFloat(selected.style.getPropertyValue(name));if(!Number.isFinite(previous)||Math.abs(previous-value)>.1)selected.style.setProperty(name,next);});
      wallets.setAttribute('data-ae-device-wallet-positioned','');
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(position);};
    const sync=()=>{
      const native=wallets.querySelector('shopify-accelerated-checkout-cart');
      const candidates=native?[...native.children].filter(node=>node.matches(selector)&&!node.hidden&&node.getAttribute('aria-hidden')!=='true'&&node.style.display!=='none'):[];
      const selected=candidates.find(node=>node.localName==='shopify-apple-pay-button')||candidates.find(node=>node.localName==='shopify-google-pay-button');
      wallets.querySelectorAll('[data-ae-device-wallet-selected]').forEach(node=>{if(node!==selected){node.removeAttribute('data-ae-device-wallet-selected');node.style.removeProperty('--ae-device-wallet-x');node.style.removeProperty('--ae-device-wallet-y');wallets.removeAttribute('data-ae-device-wallet-positioned');}});
      if(selected){
        if(!selected.hasAttribute('data-ae-device-wallet-selected'))wallets.removeAttribute('data-ae-device-wallet-positioned');
        selected.setAttribute('data-ae-device-wallet-selected','');
        wallets.dataset.aeDeviceWallet=selected.localName==='shopify-apple-pay-button'?'apple-pay':'google-pay';
      }else{delete wallets.dataset.aeDeviceWallet;wallets.removeAttribute('data-ae-device-wallet-positioned');}
      actions?.classList.toggle('has-device-wallet',Boolean(selected));
      if(wallets.hidden||wallets.inert)wallets.removeAttribute('data-ae-device-wallet-positioned');
      schedule();
    };
    new MutationObserver(sync).observe(wallets,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','inert','aria-hidden','style']});
    window.addEventListener('pageshow',sync);
    document.addEventListener('ae:cart:rendered',schedule);
    if(window.ResizeObserver&&actions)new ResizeObserver(schedule).observe(actions);
    sync();
  });
})();
